import { api } from '@/lib/api';

export interface PendingContractSummary {
  id: string;
  pendingCount: number;
}

export async function fetchPendingContractSummary(): Promise<PendingContractSummary | null> {
  const response = await api<{ data: PendingContractSummary | null }>('/student/contracts/pending');
  return response.data;
}

export async function resolveAuthenticatedHomePath(): Promise<string> {
  try {
    const pending = await fetchPendingContractSummary();
    if (pending?.id) {
      return `/mis-contratos/${pending.id}?firmar=1`;
    }
  } catch {
    // Usuario sin permiso de contratos o sin sesión válida.
  }
  return '/dashboard';
}

export function contractSigningPath(contractId: string): string {
  return `/mis-contratos/${contractId}?firmar=1`;
}
